import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import {INITIAL_USER} from 'constants/baseConst';
import {inject} from 'mobx-react';
import {USER_UPDATE_CONSTRAINS} from 'constants/usersConstrains';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';

const UPDATE_USER = '/api/v1/users';

@withRouter
@inject('userStore')
@inject('alertStore')
export default class ProfileSettings extends React.Component {

  state = {
    errors: {},
    formData: _.assign({}, INITIAL_USER, this.props.userStore.user)
  };

  submit = e => {
    e.preventDefault();
    let newFormDate = _.assign({}, this.state.formData);
    let errors = validate(newFormDate, USER_UPDATE_CONSTRAINS, {fullMessages: false});

    if (errors)
      this.setState({errors: errors});
    else {
      this.setState({errors: {}});
      let formData = this.state.formData;

      new HttpClient().put(UPDATE_USER, {user: formData}).then(data => {
        const user = data.body.data.user;
        this.props.userStore.update(user);
        this.props.alertStore.success('You successfully updated your profile');
      }).catch((e) => {
        if(e.status === 422) {
          this.handleEmailError(e.body.errors);}
        else
          this.props.alertStore.success('Something went wrong');
      });
    }
  };

  handleEmailError = errors => {
    this.setState({errors})
  };

  handleChange = e => {
    let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
    this.setState({formData: newState});
  };

  render() {
    return (
      <form className="sign-up-form" onSubmit={this.submit}>
        <div className="name-info-block">
          <div className="input-wrap">
            <TextField
              onChange={this.handleChange}
              className='name'
              name="first_name"
              disabled={this.props.userStore.user.first_name  ? true : false}
              value={this.state.formData.first_name}
              floatingLabelText="First Name"
              type="text"
              errorText={this.state.errors.first_name}
            />
          </div>
          <div className="input-wrap">
            <TextField
              className='surname'
              name="last_name"
              disabled={this.props.userStore.user.last_name  ? true : false}
              value={this.state.formData.last_name}
              errorText={this.state.errors.last_name}
              onChange={this.handleChange}
              floatingLabelText="Surname"
              type="text"
            />
          </div>
        </div>
        <div className="input-wrap">
          <TextField
            name="email"
            disabled={this.props.userStore.user.email ? true : false}
            value={this.state.formData.email}
            onChange={this.handleChange}
            className='email'
            errorText={this.state.errors.email}
            floatingLabelText="Email"
            type="email"
          />
        </div>
        <div className="input-wrap">
          <TextField
            name="university"
            value={this.state.formData.university}
            onChange={this.handleChange}
            className='email'
            errorText={this.state.errors.university}
            floatingLabelText="University"
            type="text"
          />
        </div>
        <div className="button-set">
          <button className="btn-new-main" type="submit">Save</button>
          <NavLink
            to='/logout'
            exact
            activeClassName="active"
            className="btn-new-white margin-left-20">
            Logout
          </NavLink>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/components/ProfileSettings.js